import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import RevenueIcon from '@material-ui/icons/InsertChartSharp';

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  titleIcon: {
    margin: theme.spacing(-2, 1, -2, 0),
    color: theme.palette.text.secondary
  }
}));

export const RevenueRecognitionEditableTitle = () => {
  const classes = useStyles();

  return (
    <div className={classes.header}>
      <RevenueIcon className={classes.titleIcon} />
      <FormattedMessage id="projectRevenueRecognitionCard.title" />
    </div>
  );
};

export default RevenueRecognitionEditableTitle;
